export default class ApiKeyConfig {
    constructor(
        public ClientSecretKey: string = "",
        public HeaderName: string = "",
    ) { }
}